/* eslint-disable jsx-a11y/anchor-is-valid */

import LogicContext from "../../Context/LogicContext";
import { useEffect, useRef } from "react";
import { useState } from "react";
import { useContext } from "react";
import { SetRewardRedeemStoreList, GetRewardRedeemStoreList } from "../../store/rewardRedeem";
import RestartAlt from '@mui/icons-material/RestartAlt';
import Tooltip from '@mui/material/Tooltip';
import { useLocation, useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import moment from "moment";

import { rewardService } from '../../services/Reward.service';
import GeneralCustomTable from "../../helpers/GeneralCustomTable";
import { formatCustomDate } from "../../helpers/formatCustomDate";
import { formatCustomNumber } from "../../helpers/formatCustomNumber";
import RewardRedeemSearch from "./RewardRedeemSearch";
import Papa from "papaparse";   // ← Added for reliable CSV export

const columns = [
  {
    title: 'Ref No',
    key: 'Ref_No',
    dataIndex: 'Ref_No',
    className: "text-primary",
    sorter: (a, b) => (a?.Ref_No ?? '') - (b?.Ref_No ?? '')
  },
  {
    title: "Redeem Date",
    dataIndex: "Redeem_Date",
    sorter: (a, b) => (a?.Redeem_Date ?? '').localeCompare(b?.Redeem_Date ?? ''),
    render: (record) => <span> {formatCustomDate(record)} </span>,

  },
  {
    title: "Customer",
    dataIndex: "Customer_Full_Name",
    sorter: (a, b) => (a?.Customer_Full_Name ?? '').localeCompare(b?.Customer_Full_Name ?? '')
  },
  {
    title: "Customer Address",
    dataIndex: "Customer_Email_Address",
    sorter: (a, b) => (a?.Customer_Email_Address ?? '').localeCompare(b?.Customer_Email_Address ?? '')
  },
  {
    title: "Mobile",
    dataIndex: "Customer_Mobile_No",
    sorter: (a, b) => (a?.Customer_Mobile_No ?? '').localeCompare(b?.Customer_Mobile_No ?? '')
  },
  {
    title: "Redeem Cowries",
    dataIndex: "Redeem_Cowries_Quantity",
    sorter: (a, b) => (a?.Redeem_Cowries_Quantity ?? '') - (b?.Redeem_Cowries_Quantity ?? ''),
    render: (record) => <span> {formatCustomNumber(record)} </span>,
  },
  {
    title: "Redeem Amount(₦)",
    dataIndex: "Redeem_Cowries_Amount",
    sorter: (a, b) => (a?.Redeem_Cowries_Amount ?? '') - (b?.Redeem_Cowries_Amount ?? ''),
    render: (record) => <span> {formatCustomNumber(record)} </span>,
  },
  {
    title: "Amount / Qty",
    dataIndex: "Cowries_Amount_Per_Quantity",
    sorter: (a, b) => (a?.Cowries_Amount_Per_Quantity ?? '') - (b?.Cowries_Amount_Per_Quantity ?? ''),
    render: (record) => <span> {formatCustomNumber(record)} </span>,
  },
];

function RewardRedeemPage() {
  const logicContext = useContext(LogicContext);
  const getRecoilList = GetRewardRedeemStoreList();
  const setRecoilList = SetRewardRedeemStoreList();

  const { register, getValues } = useForm();

  const [tableList, setTableList] = useState([]);

  const navigate = useNavigate();
  const mountedRef = useRef(true);

  const { pathname } = useLocation();
  var url = pathname.split("/");
  const currModuleId = url[1];
  const currModuleName = url[2];
  const currUserMenu = url[3];

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const new_list = queryParams.get('new_list');

  useEffect(() => {
    document.title = "Reward Redeem";
  }, []);

  useEffect(() => {
    if (getRecoilList.length) {
      setTableList(getRecoilList);
    } else {
      getRewardList();
    }
  }, [getRecoilList]);

  function getRewardList() {
    rewardService.getRewardRedeemList().then(response => {
      if (response?.data) {
        setRecoilList(response?.data);
        setTableList(response?.data);
      }
    });
  }

  const searchByDate = async () => {
    const formData = getValues();
    const response = await rewardService.rewardRedeemByDate(formData);
    if (response?.data?.length) {
      setTableList(response.data);
    } else {
      setTableList([]);
      logicContext.showToast("No available record for your search query!", "");
    }
  };

  const onSearchList = (list) => {
    if (list?.length) {
      setTableList(list);
    } else {
      setTableList(getRecoilList);
    }
  };

  function handleRowClick(item) {
    // NO NEED FOR DETAILS PAGE
  }

  // ====================== EXPORT CSV ======================
  const exportToCSV = () => {
    if (!tableList?.length) {
      logicContext.showToast("No data to export", "warning");
      return;
    }

    const headers = columns.map(col => col.title);
    const keys = columns.map(col => col.dataIndex);

    const dataForExport = tableList.map(row => {
      const obj = {};
      keys.forEach((key, i) => {
        let value = row[key] ?? '';

        // Apply same formatting user sees in the table
        if (key === "Redeem_Cowries_Quantity" ||
            key === "Redeem_Cowries_Amount" ||
            key === "Cowries_Amount_Per_Quantity") {
          value = formatCustomNumber(value);
        }

        obj[headers[i]] = value;
      });
      return obj;
    });

    const csv = Papa.unparse(dataForExport, { header: true });

    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `reward_redeem_${moment().format("YYYY-MM-DD_HHmmss")}.csv`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);

    logicContext.showToast("CSV exported successfully!", "success");
  };
  // =======================================================

  return (
    <>
      <section>
        <div className="w-full lg:flex justify-start">
          <section className="w-full">
            <section className="bg-white py-4 px-2 md:flex justify-between">
              <div className="flex items-center gap-4">
                {/* Reload Button */}
                <Tooltip title="Reload">
                  <RestartAlt
                    className="cursor-pointer text-blue-600 hover:text-blue-800 transition-colors self-center"
                    onClick={() => getRewardList()}
                    color="primary"
                    fontSize="large"
                  />
                </Tooltip>

                {/* Date Range Search */}
                <div className="flex items-center gap-3">
                  <div className="flex flex-col mb-3">
                    <label className="text-sm font-medium text-gray-700">From Date</label>
                    <input
                      defaultValue={moment(Date.now()).format("YYYY-MM-DD")}
                      {...register("from_date")}
                      type="date"
                      className="h-10 w-80 bg-white border border-gray-300 rounded-md px-3 py-2 text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-all"
                    />
                  </div>
                  <div className="flex flex-col mb-3">
                    <label className="text-sm font-medium text-gray-700">To Date</label>
                    <input
                      defaultValue={moment(Date.now()).format("YYYY-MM-DD")}
                      {...register("to_date")}
                      type="date"
                      className="h-10 w-80 bg-white border border-gray-300 rounded-md px-3 py-2 text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-all"
                    />
                  </div>

                  <button
                    onClick={searchByDate}
                    type="button"
                    className="mt-1 h-10 bg-blue-600 text-white text-sm font-medium rounded-md px-4 py-2 hover:bg-blue-700 transition-colors"
                  >
                    Search
                  </button>
                </div>
              </div>

              {/* Search input */}
              <div className="mt-4">
                <RewardRedeemSearch searchList={onSearchList} />
              </div>

              {/* EXPORT BUTTON */}
              <div className="flex items-center">
                <button
                  onClick={exportToCSV}
                  className="font-[Poppins] font-bold py-2 px-6 rounded text-sm bg-gray-200 hover:bg-gray-300 transition-colors mt-1"
                >
                  EXPORT
                </button>
              </div>
            </section>

            <section className="mt-5">
              <GeneralCustomTable
                tableHeadList={columns}
                tableDataList={tableList}
                allowCheckBox={false}
                rowKey={(record) => record.Ref_No}
                handleRowClick={handleRowClick}
              />
            </section>
          </section>
        </div>
      </section>
    </>
  );
}

export default RewardRedeemPage;